module.exports = __webpack_public_path__ + "static/media/location_icon.a095b95e.svg";